import axios from 'axios';
import { getToken } from './auth';

// Create instance
const instance = axios.create({
 baseURL: import.meta.env.VITE_API_BASE_URL, // Change if needed
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
instance.interceptors.request.use(
  (config) => {
    let token = getToken();

    // If token is not found via getToken(), try directly from localStorage
    if (!token) {
      token = localStorage.getItem('token');
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Response interceptor to handle 401/403 globally
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || (error.response.status === 403 && error.response.data?.error === "Invalid token"))) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login'; // or navigate programmatically if using React Router
    }
    return Promise.reject(error);
  }
);

export default instance;
